export default {
	"notification.bell.label": "Benachrichtigungen öffnen",
	"notification.title": "Sie haben neue Dokumente",
	"notification.title.empty": "Keine neuen Dokumente",
	"notification.objectId": "OBJEKT-ID: {objectId}",
} as const;
